/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    d="M10.6757 13.5411a.7407.7407 0 0 0 .9605-.0202l.0938-.0992c.2224-.2821.2217-.6942-.0198-.9767L7.0706 7.221H14.25l.3253.007c3.9912.1733 7.1747 3.5185 7.1747 7.6198 0 4.2122-3.3579 7.6268-7.5 7.6268H3.75l-.1348.0123c-.3499.0646-.6152.376-.6152.7504 0 .4212.3358.7627.75.7627h10.5l.3374-.0063c4.8142-.1804 8.6626-4.2062 8.6626-9.1459 0-5.0546-4.0294-9.1522-9-9.1522H7.5213l4.7427-4.3572.0939-.0992c.2224-.282.2218-.6941-.0197-.9767a.7413.7413 0 0 0-1.058-.0755L4.409 6.4583l6.1691 6.9874.0976.0954Z"
  />,
  'RollBack'
);
